export default class SecurityUtility {
	static isLocalStorageAllowed() {
		try {
			return !!window.localStorage;
		} catch (exception) {}

		return false;
	}
}
